(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_media-with-content_slideshow"] && !Shopify.designMode) return;
  try {
    /**
   * Media with Content Slideshow
   *
   * Tab-based content switcher that crossfades server-rendered media
   * (using the theme's video snippet / image_tag) in the parent
   * media-with-content section's media column.
   *
   * Auto-rotate: image slides use the timer; video slides advance
   * when the video ends (plays once, then moves to next slide).
   */
  for (const slideshow of document.querySelectorAll('[data-mwc-slideshow]')) {
    const tabs = Array.from(slideshow.querySelectorAll('.mwc-slide__tab'));
    const mediaDivs = Array.from(slideshow.querySelectorAll('[data-mwc-media]'));
    const panels = Array.from(slideshow.querySelectorAll('.mwc-slide__panel'));
    const panelArea = slideshow.querySelector('.mwc-slideshow__panel-area');

    if (!tabs.length || !panelArea) continue;

    const autoRotateEnabled = slideshow.dataset.autoRotate === 'true';
    const speed = Math.max((parseInt(slideshow.dataset.speed, 10) || 5) * 1000, 5000);

    let currentIndex = 0;
    let rotateTimer = null;
    let wasManuallyPaused = false;

    /* ------------------------------------------------------------------ */
    /*  Find section's media column                                       */
    /* ------------------------------------------------------------------ */
    const section = slideshow.closest('.media-with-content');
    const mediaBlock = section ? section.querySelector('.media-block') : null;

    /* ------------------------------------------------------------------ */
    /*  Move panels from tablist to panel-area                            */
    /* ------------------------------------------------------------------ */
    for (const panel of panels) {
      panel.remove();
      panelArea.appendChild(panel);
    }
    const movedPanels = Array.from(panelArea.querySelectorAll('.mwc-slide__panel'));

    /* ------------------------------------------------------------------ */
    /*  Build media overlay from server-rendered media elements            */
    /* ------------------------------------------------------------------ */
    let mediaOverlay = null;
    const mediaItems = [];

    if (mediaBlock) {
      mediaOverlay = document.createElement('div');
      mediaOverlay.className = 'mwc-slideshow__media-overlay';

      for (const mediaDiv of mediaDivs) {
        const item = document.createElement('div');
        item.className = 'mwc-slideshow__media-item';

        /*
         * Clone server-rendered content instead of moving it.
         * Moving a <deferred-media> custom element triggers disconnectedCallback
         * which aborts its internal AbortController, killing all event listeners.
         * Cloning creates a fresh element with a new lifecycle.
         *
         * Strip autoplay/data-custom-controls from cloned deferred-media so
         * its connectedCallback doesn't set up independent playback control
         * that fights with the slideshow's own play/pause logic.
         */
        for (const child of mediaDiv.children) {
          const clone = child.cloneNode(true);

          if (clone.tagName?.toLowerCase() === 'deferred-media') {
            clone.removeAttribute('autoplay');
            clone.removeAttribute('data-custom-controls');

            /* Strip poster button — the slideshow manages playback.
             * Keep video controls (mute toggle, progress, etc.) for mobile UX. */
            for (const ctrl of clone.querySelectorAll('.deferred-media__poster-button')) {
              ctrl.remove();
            }
          }

          item.appendChild(clone);
        }
        mediaDiv.remove();

        /* Remove loop so the video fires 'ended' for auto-advance,
         * and upgrade preload so the browser buffers enough to play */
        const clonedVideo = item.querySelector('video');

        if (clonedVideo) {
          clonedVideo.removeAttribute('loop');

          if (clonedVideo.preload === 'none') {
            clonedVideo.preload = 'metadata';
          }
        }

        mediaOverlay.appendChild(item);
        mediaItems.push(item);
      }

      mediaBlock.appendChild(mediaOverlay);
    }

    /* ------------------------------------------------------------------ */
    /*  Helper: get the <video> element inside a media item               */
    /* ------------------------------------------------------------------ */
    const getVideo = (item) => {
      if (!item) return null;
      return item.querySelector('video');
    };

    /* ------------------------------------------------------------------ */
    /*  Helper: check if a media item has video                           */
    /* ------------------------------------------------------------------ */
    const hasVideo = (item) => !!getVideo(item);

    /* ------------------------------------------------------------------ */
    /*  Advance to next slide                                             */
    /* ------------------------------------------------------------------ */
    const advanceToNext = () => {
      activate((currentIndex + 1) % tabs.length);
    };

    /* ------------------------------------------------------------------ */
    /*  Schedule next advance (timer for images, video-end for videos)    */
    /* ------------------------------------------------------------------ */
    const scheduleNext = () => {
      clearTimer();

      if (!autoRotateEnabled || wasManuallyPaused) return;

      const activeItem = mediaItems[currentIndex];
      const video = getVideo(activeItem);

      if (video) {
        /* Video slide: advance when video ends (plays once) */
        video.addEventListener('ended', advanceToNext, { once: true });
      } else {
        /* Image slide: use the configured timer */
        rotateTimer = setTimeout(advanceToNext, speed);
      }

      panelArea.setAttribute('aria-live', 'off');
    };

    const clearTimer = () => {
      if (rotateTimer) {
        clearTimeout(rotateTimer);
        rotateTimer = null;
      }

      /* Remove any pending video-ended listeners */
      for (const item of mediaItems) {
        const video = getVideo(item);
        if (video) video.removeEventListener('ended', advanceToNext);
      }

      panelArea.setAttribute('aria-live', 'polite');
    };

    /* ------------------------------------------------------------------ */
    /*  Activate slide                                                    */
    /* ------------------------------------------------------------------ */
    const activate = (index) => {
      clearTimer();
      currentIndex = index;

      /* Update tabs */
      for (const [i, tab] of tabs.entries()) {
        const isActive = i === index;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      }

      /* Update panels */
      for (const [i, panel] of movedPanels.entries()) {
        if (i === index) {
          panel.hidden = false;
          panel.setAttribute('data-active', '');
        } else {
          panel.hidden = true;
          panel.removeAttribute('data-active');
        }
      }

      /* Update media — fall back to section default if slide has no media */
      const activeItem = mediaItems[index];
      const activeHasMedia = activeItem && activeItem.children.length > 0;

      if (mediaBlock) {
        mediaBlock.classList.toggle('mwc-slideshow__media-controlled', activeHasMedia);
      }

      for (const [i, item] of mediaItems.entries()) {
        const isActive = i === index;
        item.classList.toggle('mwc-slideshow__media-item--active', isActive);

        const video = getVideo(item);
        if (!video) continue;

        if (isActive && isVisible) {
          video.currentTime = 0;

          if (video.readyState >= 3) {
            video.play().catch(() => {});
          } else {
            /* Video hasn't buffered enough — wait for canplay then play */
            video.addEventListener('canplay', () => video.play().catch(() => {}), { once: true });
          }
        } else {
          video.pause();
        }
      }

      /* Schedule the next auto-advance (only when visible) */
      if (autoRotateEnabled && !wasManuallyPaused && isVisible) {
        scheduleNext();
      }
    };

    /* ------------------------------------------------------------------ */
    /*  Click handlers                                                    */
    /* ------------------------------------------------------------------ */
    for (const [i, tab] of tabs.entries()) {
      tab.addEventListener('click', () => {
        wasManuallyPaused = false;
        activate(i);
      });
    }

    /* ------------------------------------------------------------------ */
    /*  Keyboard navigation                                               */
    /* ------------------------------------------------------------------ */
    const tabsContainer = slideshow.querySelector('.mwc-slideshow__tabs');

    if (tabsContainer) {
      tabsContainer.addEventListener('keydown', (e) => {
        const idx = tabs.indexOf(/** @type {HTMLElement} */ (document.activeElement));
        if (idx === -1) return;

        let newIndex;

        switch (e.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            e.preventDefault();
            newIndex = (idx + 1) % tabs.length;
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            e.preventDefault();
            newIndex = (idx - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            e.preventDefault();
            newIndex = 0;
            break;
          case 'End':
            e.preventDefault();
            newIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        tabs[newIndex].focus();
        activate(newIndex);
      });
    }

    /* ------------------------------------------------------------------ */
    /*  Pause on hover / focus                                            */
    /* ------------------------------------------------------------------ */
    slideshow.addEventListener('mouseenter', () => {
      if (autoRotateEnabled && !wasManuallyPaused) clearTimer();
    });

    slideshow.addEventListener('mouseleave', () => {
      if (autoRotateEnabled && !wasManuallyPaused && isVisible) scheduleNext();
    });

    slideshow.addEventListener('focusin', () => {
      if (autoRotateEnabled && !wasManuallyPaused) clearTimer();
    });

    slideshow.addEventListener('focusout', (e) => {
      if (!slideshow.contains(e.relatedTarget) && autoRotateEnabled && !wasManuallyPaused && isVisible) {
        scheduleNext();
      }
    });

    /* ------------------------------------------------------------------ */
    /*  Visibility observer — only run when in viewport                   */
    /* ------------------------------------------------------------------ */
    let isVisible = false;

    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;

        if (isVisible) {
          if (autoRotateEnabled && !wasManuallyPaused) scheduleNext();

          /* Resume video on active slide */
          const activeVideo = getVideo(mediaItems[currentIndex]);
          if (activeVideo && activeVideo.paused) {
            activeVideo.play().catch(() => {});
          }
        } else {
          clearTimer();

          /* Pause video when out of view */
          const activeVideo = getVideo(mediaItems[currentIndex]);
          if (activeVideo) activeVideo.pause();
        }
      },
      { threshold: 0 }
    );

    /* Observe the section (or media block) so the video plays when
     * any part is in the viewport — on mobile the tabs area may be
     * scrolled off while the media column is still visible. */
    observer.observe(section || slideshow);

    /* ------------------------------------------------------------------ */
    /*  Initialize                                                        */
    /* ------------------------------------------------------------------ */
    activate(0);
  }
  } catch(e) { console.error(e); }
})();

})();
